import React from 'react';


const Attributions = () => {

    return (
        <div style={{marginTop: '40px'}}>
            <iframe title="igem-attribution-form" style={{width: '100%', height: '100vh',  border: 'none', overflow: 'hidden'}} id="igem-attribution-form" src="https://attributions.igem.org?team=paris-bettencourt&year=2023">
            </iframe>
        </div>
    )
}
export default Attributions;